import { ROLE_LABEL_KEYS } from "@/domain/permissions";
import { useI18n } from "@/i18n/useI18n";
import { useApp, useUi, useUiDispatch } from "./AppContext";
import { useAutoHideHeader } from "./useAutoHideHeader";

export function AppHeader() {
  const { t } = useI18n();
  const { authMode, user, data, signOut } = useApp();
  const { language, tab } = useUi();
  const dispatch = useUiDispatch();
  const headerRef = useAutoHideHeader(tab);
  // Shared-password deployments have no personal account to show.
  const signedInAs =
    authMode === "individual" && user ? `${user.email} (${t(ROLE_LABEL_KEYS[user.role])})` : null;

  return (
    <div className="app-header" ref={headerRef}>
      <div className="app-header-brand">
        <span className="app-header-logo">vRePS</span>
        <span className="app-header-tagline">
          Prevention system
          <br />
          visualizer
        </span>
      </div>
      <div className="app-header-actions">
        {signedInAs && (
          <span className="app-header-user" title={signedInAs}>
            {signedInAs}
          </span>
        )}
        <span id="language-buttons" role="group" aria-label="Språk / Language">
          {data.settings.languages.map((entry) => {
            const label = `${entry.name} (${entry.code})`;
            return (
              <button
                key={entry.code}
                type="button"
                className={`lang-btn${entry.code === language ? " active" : ""}`}
                title={label}
                aria-label={label}
                aria-pressed={entry.code === language}
                onClick={() => dispatch({ type: "setLanguage", language: entry.code })}
              >
                {entry.code.slice(0, 2).toUpperCase()}
              </button>
            );
          })}
        </span>
        <button
          type="button"
          className="logout-btn"
          title={t("logout")}
          aria-label={t("logout")}
          onClick={signOut}
        >
          ⏻
        </button>
      </div>
    </div>
  );
}
